import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  SimpleChanges,
} from '@angular/core';
import { CommonLookupItem } from '@admin/shared/models/common-lookup-item.model';
import { TransactionListService } from '@admin/billing/transactions/shared/services/transaction-list.service';
import { SendInvoiceRequestModel } from '@admin/billing/shared/send-invoice-request-model';
import { ApplicationMessage } from '@admin/core/models/application-message';
import { MessageType } from '@admin/core/models/enum/message-type';
import { ApplicationMessageSource } from '@admin/core/models/application-message-source';
import { CustomMessageService } from '@admin/core/message.service';

@Component({
  selector: 'hr-order-confirmation-dialog',
  templateUrl: './order-confirmation-dialog.component.html',
  styleUrls: ['./order-confirmation-dialog.component.less'],
  standalone: false,
})
export class OrderConfirmationDialogComponent implements OnInit {
  public display: boolean;

  @Input()
  public transactions: number[]; // transactionId

  @Output()
  public onUpdate: EventEmitter<boolean> = new EventEmitter<boolean>();

  public customerAgents: any[]; // <id, name>
  public selectedCustomerAgents: any[];

  constructor(
    private transactionService: TransactionListService,
    private messageService: CustomMessageService
  ) {
    this.display = false;
    this.customerAgents = [];
    this.selectedCustomerAgents = [];
  }

  sendConfirmationRequest() {
    if (this.transactions == null || this.transactions.length == 0) {
      this.onCancel();
      return;
    }
    var confirmData = new SendInvoiceRequestModel();
    (confirmData.markedEntities = this.transactions),
      (confirmData.chosenCustomerAgents =
        this.selectedCustomerAgents.length > 0
          ? this.selectedCustomerAgents
          : null);

    this.transactionService
      .sendConfirmation(confirmData)
      .subscribe((result) => {
        if (result.success) {
          if (result.sent) {
            this.display = false;
            this.onUpdate.emit(true);
            this.messageService.pushMessage(<ApplicationMessage>{
              type: MessageType.Success,
              sourceId: ApplicationMessageSource.global,
              summary: '',
              detail: result.displayMessage,
            });
          } else {
            this.customerAgents = this.convertToListBoxItem(result.agents);
            this.display = true;
            this.messageService.pushMessage(<ApplicationMessage>{
              type: MessageType.Info,
              sourceId: ApplicationMessageSource.global,
              summary: '',
              detail: result.displayMessage,
            });
          }
        } else {
          this.messageService.pushMessage(<ApplicationMessage>{
            type: MessageType.Error,
            sourceId: ApplicationMessageSource.global,
            summary: '',
            detail: result.displayMessage,
          });
          this.onCancel();
        }
      });
  }

  convertToListBoxItem(data: CommonLookupItem<number, string>[]) {
    var result = [];
    data.forEach((k) => {
      result.push({ label: k.text, value: k.value });
    });

    return result;
  }

  onCancel() {
    this.display = false;
    this.onUpdate.emit(false);
  }

  ngOnInit() {
    this.sendConfirmationRequest();
  }
}
